import { useState } from 'react';
import { Modal } from '@medeloop/medeloop-components-library';

interface SaveCodeSetModalProps {
  isCodeSetDialogOpen: boolean;
  initialCodeSetName: string;
  initialDescription: string;
  setIsCodeSetDialogOpen: (isOpen: boolean) => void;
  onSave?: (name: string, description: string) => void;
}

const SaveCodeSetModal = ({
  isCodeSetDialogOpen,
  setIsCodeSetDialogOpen,
  onSave,
  initialCodeSetName,
  initialDescription,
}: SaveCodeSetModalProps) => {
  const [codeSetName, setCodeSetName] = useState(initialCodeSetName);
  const [description, setDescription] = useState(initialDescription);

  const handleCancel = () => {
    setCodeSetName('');
    setDescription('');
    setIsCodeSetDialogOpen(false);
  };

  const handleSave = async () => {
    if (onSave) {
      onSave(codeSetName, description);
    }
    setCodeSetName('');
    setDescription('');
    setIsCodeSetDialogOpen(false);
  };

  return (
    <Modal
      title="Save code set"
      isOpen={isCodeSetDialogOpen}
      onCancel={() => handleCancel()}
      actionFunction={() => handleSave()}
      cancelText="Cancel"
      actionType="primary"
      actionText="Save"
      disabled={!codeSetName}
    >
      <div className="max-w-md">
        <div className="space-y-4">
          <div>
            <label className="block text-white mb-2">Code set name</label>
            <input
              type="text"
              className="w-full bg-gray-900 text-white p-3 rounded-md border border-gray-700"
              value={codeSetName}
              onChange={(e) => setCodeSetName(e.target.value)}
              placeholder="Name"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Description</label>
            <textarea
              className="w-full bg-gray-900 text-white p-3 rounded-md border border-gray-700 h-32 resize-none"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SaveCodeSetModal;
